import { useMemo } from 'react'

export function useIsAIUserAgent(): boolean {
	return useMemo(() => {
		if (typeof window === 'undefined') {
			// In SSR, we don't have access to the user agent, so we return false
			return false
		}
		const userAgent = navigator.userAgent || navigator.vendor // || (window as any).opera

		//Known AI user agents Sept 2025
		const aiUserAgentPattern =
			/\b(GPTBot|ChatGPT-User-Agent|ChatGPT-User|ChatGPT|ClaudeBot|Claude-Web|AnthropicAI|PerplexityBot|Perplexity|pplxbot|YouBot|GrokCrawler|Grok|GrokFetcher|Applebot-Extended|facebookexternalhit|Meta-ExternalAgent|Meta-FeedbackAgent|Amazonbot|Bytespider|CCBot|AI2Bot|Diffbot|Molly|OpenAI-Replay-Bot)\b/i

		return aiUserAgentPattern.test(userAgent)
	}, [])
}
